import { Button } from '@ui/shared/Button';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { LIST_ROW_HEIGHTS } from '../../../constants/list_row_heights';
import {
  closeInnerPopup,
  openInnerPopup,
} from '../../../data/providers/popupsProvider';
import { Entity, EntityType, ITest } from '../../../data/types';
import { testMetaString } from '../../../utils/testMetaString';
import { Column } from '../../layout/Column';
import { Row } from '../../layout/Row';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import { CardFooter } from '../../shared/card/CardFooter';
import { CardHeader } from '../../shared/card/CardHeader';
import { List } from '../../shared/List/List';
import { ListAvatar } from '../../shared/List/ListAvatar';
import { ListHeader } from '../../shared/List/ListHeader';
import { ListItem, ListItemCell } from '../../shared/List/ListItem';
import { LinearLoading } from '../../shared/loading/LinearLoading';
import { NoResults } from '../../shared/NoResults';
import { DeleteTest } from '../test/DeleteTest';
import { SessionExportPopup } from './SessionExportPopup';

interface IProps extends RouteComponentProps {
  data: ITest[];
  selectTest: (t: string) => void;
  selectedTest?: string;
  loading: boolean;
  sessionId: number;
  entity: Entity;
  entityType: EntityType;
}

const listShape = [3, 1];
export const SessionTestList = withRouter(
  (props: IProps): React.ReactElement => {
    const rowRenderer = ({
      index,
      key,
      style,
    }: {
      index: number;
      key: string;
      style: React.CSSProperties;
    }): React.ReactElement => {
      const row = props.data[index];
      const clickHandler = (): void => props.selectTest(row.id);

      const secondaryText = testMetaString(row.testType.abbr, row.tags);

      return (
        <ListItem
          onClick={clickHandler}
          key={key}
          style={style}
          selected={row.id === props.selectedTest}
        >
          <ListItemCell style={{ flex: listShape[0] }}>
            <ListAvatar entity={row.athlete} secondaryText={secondaryText} />
          </ListItemCell>

          <ListItemCell style={{ flex: listShape[1] }}>
            <DeleteTest testId={row.id} />
          </ListItemCell>
        </ListItem>
      );
    };

    const openExport = (): void =>
      openInnerPopup(
        <SessionExportPopup
          entity={props.entity}
          entityType={props.entityType}
          sessionId={props.sessionId}
          closeDialog={closeInnerPopup(props.history)}
        />,
        props.history,
        'export'
      );

    return (
      <Card
        style={{
          padding: '0px',
          overflow: 'hidden',
          marginTop: 'var(--grid-gap)',
        }}
      >
        <Column>
          <CardHeader withListHeader surface={8}>
            <Column>
              <ListHeader labels={['Athlete', 'Actions']} shape={listShape} />
            </Column>
          </CardHeader>
          <CardBody>
            {props.loading ? (
              <LinearLoading />
            ) : props.data && props.data.length > 0 ? (
              <List
                listLength={props.data.length}
                rowRenderer={rowRenderer}
                rowHeight={LIST_ROW_HEIGHTS.normal}
              />
            ) : (
              <NoResults message='No Tests' />
            )}
          </CardBody>

          <CardFooter surface={8}>
            <Row style={{ justifyContent: 'center' }}>
              <Button onClick={openExport} title='Export Tests' />
            </Row>
          </CardFooter>
        </Column>
      </Card>
    );
  }
);
